export default "__VITE_ASSET__CeN3Idg8__$_?height=200&width=300__"